import React, {Component} from 'react';
import {Route, Switch, withRouter, Redirect} from 'react-router-dom';
import {connect} from 'react-redux';
import {IntlProvider} from 'react-intl';

import Layout from './hoc/Layout';
import Homepage from './components/Homepage';
import SignHomepage from './containers/signHomepage';
import Login from './containers/Login';
import Register from './containers/Register';
import Logout from './containers/Logout';
import RegisterCode from './containers/codes/RegisterCode';
import ViewCodes from './containers/codes/Codes';
import CodeInfo from './containers/codes/CodeInfo';
import CodeEdit from './containers/codes/CodeEdit';
import RecoverPassword from './containers/RecoverPw';
import Indicators from './components/Indicators';
import PersonalIndicators from './components/Pers_Indicators';
//import DirectorIndicators from './components/Director_Indicators';
import FormEdit from './containers/FormEdit';
import LoginLogs from './containers/logs';
import Profile from './containers/Profile';
import Config from './containers/Configs';
import RGPD from './components/rgpd';
import InitialRGPD from './components/initialRGPD';
import RGPDOptions from './containers/rgpdOptions';
import Opinions from './containers/opinions';
import Permissions from './containers/permissionsManagement';
import QuestSUS from './containers/questSUS';

import ContextProvider from './contextProvider';

//import Empty from './components/empty';


//import Aux from './hoc/auxi';

import Admin from './containers/Admin';
import Dashboard from './containers/Dashboard';
import SearchForm from './containers/SearchForm';

import * as actions from './store/actions/index';
import language_pt from './languages/language_pt';
import language_en from './languages/language_en';

import {library} from '@fortawesome/fontawesome-svg-core'
//import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faStroopwafel} from '@fortawesome/free-solid-svg-icons'
//import { faTrashAlt } from '@fortawesome/free-solid-svg-icons'


library.add(faStroopwafel);

function Fragment(props) {
    return props.children || <span {...props} /> || null;
}



class App extends Component {

    componentDidMount() {
        this.props.onTryAutoSignUp();
    };

    handleChangeUserType = (value)=>{
        this.setState({userType:value})
    };

    render() {
        let routes = null;
        localStorage.setItem('language', 'pt'); //editado 14 maio 2019

        //this.props.onTryAutoSignUp();
        //console.log("props--->> " + JSON.stringify(this.props));
        //console.log();
        //console.log("Visitor:" + this.props.isVisitor);
        //console.log("Auth:" + this.props.isAuth);
        //console.log("Director:" + this.props.isDirector);
        //console.log("Admin: " + this.props.isAdmin);
       // console.log("profile: " + this.props.profile);
        //console.log("firstTImeAPP: " + this.props.firstTime);
        if (this.props.isAuth) {
            if(this.props.firstTime){
                routes=(
                    <Switch>
                        <Route path="/termsAccept" component={RGPDOptions}/>
                        <Redirect to="/termsAccept"/>
                    </Switch>
                )
            }
            else if (this.props.isAdmin) {
                //console.log("Entrei no administrador");
                routes = (
                    <Switch>
                        <Route path="/codes/:code" component={CodeInfo}/>
                        <Route path="/rgpd" component={RGPD}/>
                        <Route path="/registercode" component={RegisterCode}/>
                        <Route path="/codes" component={ViewCodes}/>
                        <Route path="/edit/:code" component={CodeEdit}/>
                        <Route path="/indicators" component={Indicators}/>
                        <Route path="/personal_indicators" component={PersonalIndicators}/>
                        <Route path="/profile" component={Profile}/>
                        <Route path="/logout" component={Logout}/>
                        <Route path="/dashboard" component={Dashboard}/>
                        <Route path="/admin" component={Admin}/>
                        <Route path="/editcodes" component={SearchForm}/>
                        <Route path="/formedit/:code" component={FormEdit}/>
                        <Route path="/login_logs" component={LoginLogs}/>
                        <Route path="/configurations" component={Config}/>
                        <Route path="/suggestions" component={Opinions}/>
                        <Route path="/permissions" component={Permissions}/>
                        <Route path='/usability' component={QuestSUS}/>
                        <Route path="/" exact component={SignHomepage}/>
                        <Redirect to="/"/>
                    </Switch>
                )
            }
             /*else if (this.props.isDirector) {
                //console.log("Entrei no diretor");
                routes = (
                    <Switch>
                        <Route path="/codes/:code" component={CodeInfo}/>
                        <Route path="/rgpd" component={RGPD}/>
                        <Route path="/registercode" component={RegisterCode}/>
                        <Route path="/codes" component={ViewCodes}/>
                        <Route path="/edit/:code" component={CodeEdit}/>
                        <Route path="/indicators" component={Indicators}/>
                        <Route path="/personal_indicators" component={PersonalIndicators}/>
                        <Route path="/director_indicators" component={DirectorIndicators}/>
                        <Route path="/profile" component={Profile}/>
                        <Route path="/logout" component={Logout}/>
                        <Route path="/" exact component={SignHomepage}/>
                        <Redirect to="/"/>
                    </Switch>
                )
            } else if (this.props.isQuest) {
                //insert quest
                routes = (
                    <Switch>
                        <Route path="/codes/:code" component={CodeInfo}/>
                        <Route path="/rgpd" component={RGPD}/>
                        <Route path="/registercode" component={RegisterCode}/>
                        <Route path="/codes" component={ViewCodes}/>
                        <Route path="/edit/:code" component={CodeEdit}/>
                        <Route path="/indicators" component={Indicators}/>
                        <Route path="/personal_indicators" component={PersonalIndicators}/>
                        <Route path="/profile" component={Profile}/>
                        <Route path="/logout" component={Logout}/>
                        <Route path="/dashboard" component={Dashboard}/>
                        <Route path="/admin" component={Admin}/>
                        <Route path="/editcodes" component={SearchForm}/>
                        <Route path="/formedit/:code" component={FormEdit}/>
                        <Route path="/login_logs" component={LoginLogs}/>
                        <Route path="/configurations" component={Config}/>
                        <Route path="/" exact component={SignHomepage}/>
                        <Redirect to="/"/>
                    </Switch>
                )*/

             else {
                //console.log("Entrei no utilizador");
                routes = (
                    <Switch>
                        <Route path="/codes/:code" component={CodeInfo}/>
                        <Route path="/RGPD" component={RGPD}/>
                        <Route path="/registercode" component={RegisterCode}/>
                        <Route path="/codes" component={ViewCodes}/>
                        <Route path="/edit/:code" component={CodeEdit}/>
                        <Route path="/indicators" component={Indicators}/>
                        <Route path="/personal_indicators" component={PersonalIndicators}/>
                        <Route path="/profile" component={Profile}/>
                        <Route path="/logout" component={Logout}/>
                        <Route path="/suggestions" component={Opinions}/>
                        <Route path="/" exact component={SignHomepage}/>
                        <Redirect to="/"/>
                    </Switch>
                )
            }
        } else{
            //console.log("Entrei no visitante");
            routes = (
                <Switch>
                    <Route path="/login" component={Login}/>
                    <Route path="/register" component={Register}/>
                    <Route path="/terms" component={InitialRGPD}/>
                    <Route path="/recover" component={RecoverPassword}/>
                    <Route path="/" exact component={Homepage}/>
                    <Redirect to="/"/>
                </Switch>
            );
        }

        let dir = null;
        if (this.props.language === 'en') {
            dir = language_en['en']
        }

        if (this.props.language === 'pt') {
            dir = language_pt['pt']
        }


        return (
            <IntlProvider locale={this.props.language} messages={dir} textComponent={Fragment}>
                    <div className="App">
                        <ContextProvider value="user">
                            <Layout>
                                {routes}
                            </Layout>
                        </ContextProvider>
                    </div>
            </IntlProvider>
        );
    }
}

const mapStateToProps = state => {
    return {
        isAuth: state.login.token !== null,
        isUser: state.login.profile === 1,
        isAdmin: state.login.profile === 2,
        isDoctor: state.login.profile === 3,
        isDirector: state.login.profile === 4,
        isVisitor: state.login.profile === 5 || state.login.profile === null,
        isQuest: state.login.profile === 6,
        /*isDirector: state.login.department !== null && state.login.profile == 4,*/
        language: state.language.lang,
        firstTime: state.login.firstTime,
        /*profile: state.login.profile*/
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onTryAutoSignUp: () => dispatch(actions.loginCheckState())
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));



// WEBPACK FOOTER //
// ./src/App.js